import { IconsType } from 'assets/types'
import AppColors from 'constants/colors'

export const organisationCellConfig = {
  color: '#bdffff',
  bg: `${AppColors.blue100}26`,
  icon: IconsType.organization,
  iconPathClass: `fill-[#bdffff]`,
}
